<!-- eslint-disable -->
<template>
  <div :class="`search-widget search-widget--${type}`">
    <form :class="{ 'searchbar': true, 'searchbar--open': val.length }">
      <VTooltip v-if="type != 'menu-overlay'" distance="-1" theme="search-widget" :shown="val.length"
        :container="`.search-widget--${type}`">
        <!-- This will be the popover reference (for the events and position) -->
        <input ref="searchInput" type="search" v-model="val" @input="onSearchInput" :placeholder="ph[type]">

        <!-- This will be the content of the popover -->
        <template #popper>
          <SearchWidgetResults :hits="hits" :val="val" :loading="loading" :type="type" />
        </template>
      </VTooltip>
      <div v-else>
        <input ref="searchInput" type="search" v-model="val" @input="onSearchInput" :placeholder="ph[type]">
        <SearchWidgetResults v-if="val.length" :hits="hits" :val="val" :loading="loading" :type="type" />
      </div>
      <input v-show="!val.length" @click.prevent="onSubmitButtonClick" type="submit"
        :value="Drupal.t('sitewide.search.submit')">
      <button v-show="val.length" @click.prevent="onClearClick" class="searchbar__clear">
        <Icon name="close" />
      </button>
    </form>
  </div>
</template>

<script src="./SearchWidget.js"></script>
<style src="./SearchWidget.scss" lang="scss"></style>
<style src="./v-popper--theme-search-widget.scss" lang="scss"></style>
<!-- eslint-enable -->
